// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"0a90b9ff","700":"fa32ada7"}[chunkId] + ".chunk.css";
};